import { Toaster } from '@sourcewiz/the-source';
import { useSelector } from 'react-redux';
export default function Toast() {
	const message = useSelector((state) => state.message);
	return message.open ? <Toaster {...message} /> : <></>;
}
